module.exports = __webpack_public_path__ + "img/ic_like_curve_active.eab9417b.svg";